import ContentResolver from './containers/ContentResolver'
import Profile from './containers/Profile'
import Search from './containers/Search'

const routes = [
  { path: '/profile', exact: true, component: Profile },
  { path: '/search', exact: true, component: Search },
  { path: '*', component: ContentResolver },
]

export default routes
